<template>
  <page>
    <v-card outlined>
      <v-card-title>Конфигурация системы</v-card-title>

      <v-divider />

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="systemName"
              label="Название системы"
              placeholder="БГПУ"
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h4 class="mb-2">Модули системы</h4>
            <v-row>
              <v-col
                v-for="module in availableModules"
                :key="module.value"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-switch
                  v-model="module.enabled"
                  :label="module.label"
                  inset
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="save" :loading="saving">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </page>
</template>

<script>
import {
  getConfig,
  loadConfig,
  updateConfig
} from "@/services/systemConfig.service";
import Page from "@/components/Page";

const ALL_MODULES = [
  { value: "exam", label: "Экзаменационные ведомости" },
  { value: "rating", label: "Рейтинг" },
  { value: "labels", label: "Метки" },
  { value: "keys", label: "Ключи" },
  { value: "events", label: "Мероприятия" },
  { value: "personal-area", label: "Личный кабинет" },
  { value: "bot", label: "Бот" },
  { value: "pass", label: "Пропуска" },
  { value: "tags", label: "Метки" }
];

export default {
  name: "SystemConfig",
  components: { Page },

  data() {
    return {
      systemName: "",
      saving: false,
      availableModules: ALL_MODULES.map(m => ({ ...m, enabled: false })),
      storageId: null
    };
  },

  async mounted() {
    await loadConfig();
    const config = getConfig();

    if (config) {
      this.systemName = config["system-name"] || "";
      this.availableModules = ALL_MODULES.map(m => ({
        ...m,
        enabled: config.modules ? config.modules.includes(m.value) : false
      }));
    }

    // получаем storage id для сохранения
    try {
      const { Api } = await import("@/services/api.service");
      const storage = await Api.get("/storage/by-key", {
        params: { key: "system-config" }
      });
      this.storageId = storage ? storage.id : null;
    } catch (e) {
      console.error("Ошибка получения storage id:", e);
    }
  },

  methods: {
    async save() {
      this.saving = true;
      try {
        const modules = this.availableModules
          .filter(m => m.enabled)
          .map(m => m.value);

        const value = JSON.stringify({
          "system-name": this.systemName,
          modules
        });

        await updateConfig(this.storageId, value);
        await loadConfig();
        location.reload();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
